<span class="file-line" [ngSwitch]="displayAs"
  ><span class="file-line__path">{{ path }}</span
  ><span class="file-line__name" *ngSwitchCase="'link'"
    ><a
      class="file-line__link"
      href="{{ url }}"
      title="Open file"
      target="_blank"
      >{{ name }}</a
    ></span
  ><span class="file-line__name" *ngSwitchCase="'text'">{{ name }}</span
  ><span class="file-line__colon">:</span
  ><span class="file-line__line">{{ line }}</span
  ><span class="file-line__colon" *ngIf="column > 0">:</span
  ><span class="file-line__column" *ngIf="column > 0">{{ column }}</span></span
>
